import { render, staticRenderFns } from "./user-balance.vue?vue&type=template&id=361a05fb"
import script from "./user-balance.vue?vue&type=script&lang=js"
export * from "./user-balance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports